import React, { useState } from 'react';
import CheckboxTree from 'react-checkbox-tree';

const CheckBoxTreeLocation = (props) => {
    const { slideType, onlyLeafCheckboxes, arrLocations, summaryLocationsID, locationsID, setLivefeedOptionsHandle } = props
    const [expanded, setExpanded] = useState([])

    // filter out node if slideType is slideShow page
    // filter arrLocations based on summaryLocationsID, if summaryLocationsID is empty, then there is no summary page, no need to filter
    let arrLocationsFiltered = arrLocations.filter((item) => {
        if (slideType !== "summary") {
            return summaryLocationsID.length > 0 ? summaryLocationsID.includes(item.id) : item
        } else {
            return item
        }
    })

    let itemsByID = [];
    arrLocationsFiltered.forEach((item, index) => {
        return itemsByID[index] = {
            useownfp: item.useownfp,
            value: item.id,
            label: item.label,
            children: [],
            parentID: item.values.parent ? item.values.parent.id : null,
            type: item.values.type
        };
    });
    let delItems = []
    itemsByID.forEach((item) => {
        if (item.parentID !== null) {
            for (let i = 0, n = itemsByID.length; i < n; i++) {
                if (itemsByID[i].value === item.parentID) {
                    itemsByID[i].children.push(item);
                    delItems.push(item)
                }
            }

        }
    });
    let newTree = null

    if (slideType === "summary") {
        newTree = itemsByID.filter((item) => { return item.parentID === null; });
    }
    newTree = itemsByID.filter((obj) => { return delItems.indexOf(obj) == -1; });

    itemsByID.forEach((item) => { delete item.parentID; });

    function onCheckHandle(checked, targetNode) {
        // console.log("targetNode", targetNode)
        let arraryNums = []
        for (let i = 0, n = checked.length; i < n; i++) {
            arraryNums.push(Number(checked[i]))
        }
        setLivefeedOptionsHandle(arraryNums)
    }


    return (
        <CheckboxTree
            checkModel="all"
            onlyLeafCheckboxes={onlyLeafCheckboxes}
            nodes={newTree}
            checked={locationsID}
            expanded={expanded}
            onCheck={(checked, targetNode) => onCheckHandle(checked, targetNode)}
            onExpand={expanded => setExpanded(expanded)}
            icons={{
                check: <i className="material-icons checked">check_box</i>,
                uncheck: <i className="material-icons">check_box_outline_blank</i>,
                halfCheck: <i className="material-icons">check_box_outline_blank</i>,
                expandClose: <i className="material-icons expand">add_circle_outline</i>,
                expandOpen: <i className="material-icons expand expand-active">remove_circle_outline</i>,

                expandAll: <i className="material-icons hidden">remove_circle_outline</i>,
                collapseAll: <i className="material-icons hidden">remove_circle_outline</i>,
                parentClose: <i className="material-icons hidden">remove_circle_outline</i>,
                parentOpen: <i className="material-icons hidden">remove_circle_outline</i>,
                leaf: <i className="material-icons hidden">remove_circle_outline</i>
            }}
        />
    );
}


export default CheckBoxTreeLocation;


// WEBPACK FOOTER //
// ./src/components/pages/livefeed/Editor/EditorContainer/FloorplanOptionContainer/LocationOption/CheckBoxTreeLocation/index.jsx